import React from "react";
import { X } from "lucide-react";
import { GradientCheck } from "./GradientCheck";

const without = [
  "Bezoekers zoeken zelf naar antwoorden",
  "Vragen blijven onbeantwoord buiten kantooruren",
  "Veel geïnteresseerden vertrekken zonder contact",
  "Uw team beantwoordt telkens dezelfde vragen",
  "Aanvragen komen vaak onvolledig binnen",
];

const withBot = [
  "Bezoekers krijgen direct antwoord",
  "De chatbot helpt 24/7",
  "Meer bezoekers laten gegevens achter",
  "Uw team krijgt minder herhalende vragen",
  "Aanvragen komen duidelijker binnen",
];

export const WhyNow = () => {
  return (
    <section className="relative py-16 md:py-20">
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div
          className="absolute top-10 left-1/2 -translate-x-1/2 h-[360px] w-[760px] blur-3xl opacity-15"
          style={{ background: "radial-gradient(ellipse, rgba(0,239,255,0.3), transparent 70%)" }}
        />
      </div>

      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.22em] font-mono-display text-[#00FFB7]">
            Waarom nu?
          </span>
          <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-[42px] tracking-tight leading-[1.1]">
            De meeste websites{" "}
            <span className="text-gradient-neon">verliezen bezoekers</span> zonder dat
            u het merkt
          </h2>
          <p className="mt-5 text-[#A7A7A7] text-base md:text-[17px] leading-relaxed">
            Veel bedrijven investeren in een website, advertenties of social media,
            maar laten bezoekers daarna zelf zoeken. Als iemand geen snel antwoord
            vindt, is de kans groot dat die persoon wegklikt.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {/* Without */}
          <div
            data-testid="whynow-without"
            className="relative rounded-2xl p-7 border border-white/5 bg-[#0E1320]/60"
          >
            <div className="flex items-center justify-between">
              <h3 className="font-display text-lg font-semibold text-white/80">
                Zonder AI-chatbot
              </h3>
              <span className="text-[10px] uppercase tracking-wider text-[#A7A7A7] px-2 py-1 rounded-full border border-white/10">
                Vandaag
              </span>
            </div>

            <ul className="mt-5 space-y-3">
              {without.map((t, i) => (
                <li key={i} className="flex items-start gap-3 text-[#A7A7A7]">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full border border-white/10 bg-white/[0.02] shrink-0">
                    <X className="h-3 w-3 text-[#A7A7A7]" />
                  </span>
                  <span className="text-[15px]">{t}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* With */}
          <div
            data-testid="whynow-with"
            className="relative rounded-2xl p-7 glass-strong glow-cyan border border-[#00EFFF]/25"
          >
            <div
              className="absolute -top-16 -right-10 h-48 w-48 rounded-full blur-3xl opacity-50 pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(168,255,0,0.35), transparent 70%)" }}
            />
            <div className="relative flex items-center justify-between">
              <h3 className="font-display text-lg font-semibold text-white">
                Met <span className="text-gradient-neon">Marlea AI</span>
              </h3>
              <span className="text-[10px] uppercase tracking-wider text-[#0A0A1A] px-2 py-1 rounded-full bg-gradient-neon font-semibold">
                24/7 aanwezig
              </span>
            </div>

            <ul className="relative mt-5 space-y-3">
              {withBot.map((t, i) => (
                <li key={i} className="flex items-start gap-3 text-white/90">
                  <GradientCheck size={18} className="mt-[3px]" />
                  <span className="text-[15px]">{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNow;
